import React, { useState, useRef, useEffect } from "react";
import { LexicalTextEditor } from "@innoviatech/lexical-text-editor";
import "@innoviatech/lexical-text-editor/style.css";

const RichTextEditorV1 = ({ item, onChange }) => {
  const [content, setContent] = useState(item.defaultValue || "");
  const [preProcess, setPreProcess] = useState(false);
  const preProcessRef = useRef(preProcess);
  useEffect(() => {
    preProcessRef.current = preProcess;
  }, [preProcess]);

  const handleChange = (value) => {
    setContent(value);
    if (onChange) {
      onChange(value);
    }
  };

  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file, file.name);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}api/v1/image-upload?process=${preProcessRef.current}`,
        { method: "POST", body: formData }
      );
      const result = await res.json();
      if (res.ok && result.filename) {
        return `${process.env.REACT_APP_API_URL}images/${result.filename}`;
      }
      throw new Error(result.error || "Upload failed");
    } catch (err) {
      console.error("Image upload error:", err);
      throw err;
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        {item.label && (
          <label className="block font-semibold text-[#1f2937] mb-1">
            {item.label}
          </label>
        )}
        <div className="flex items-center text-sm">
          Image Process
          <input
            type="checkbox"
            checked={preProcess}
            onChange={(e) => setPreProcess(e.target.checked)}
            className="ml-2 w-4 h-4 accent-white cursor-pointer"
          />
        </div>
      </div>
      <LexicalTextEditor
        name={item.name}
        value={content}
        onChange={handleChange}
        onImageUpload={handleImageUpload}
        placeholder="Start typing your content here..."
        height="500px"
        maxWidth="100%"
      />
    </div>
  );
};

export default RichTextEditorV1;
